import SocialButtonAppleContainer from './SocialButtonApple.container';
import SocialButtonApple from './SocialButtonApple';
export default SocialButtonAppleContainer(SocialButtonApple);
